<template>
  <q-input label="API Key" :model-value="apiKey" outlined readonly>
    <template v-slot:append>
      <regenerate-api-key-btn
        :service-account-id="serviceAccount.id"
        @regenerated="onRegenerated"
      />
    </template>
  </q-input>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ServiceAccount } from '@/iam/types';
import RegenerateApiKeyBtn from './RegenerateApiKeyBtn.vue';

interface Data {
  newKey: string,
}

export default defineComponent({
  emits: ['update:service-account'],
  components: { RegenerateApiKeyBtn },
  props: {
    serviceAccount: {
      type: Object as () => ServiceAccount,
      required: true,
    },
  },
  data(): Data {
    return {
      newKey: '',
    };
  },
  computed: {
    apiKey(): string {
      if (this.newKey) return this.newKey;
      const mask = '*'.repeat(10);
      return `${this.serviceAccount.apiKeyPrefix}${mask}`;
    },
  },
  methods: {
    onRegenerated(apiKey: string): void {
      this.newKey = apiKey;
      this.$emit('update:service-account', {
        ...this.serviceAccount,
        apiKey,
        apiKeyPrefix: apiKey.substr(0, 8),
      });
    },
  },
});
</script>
